import { useEffect, useState } from "react";
import { MousePointerClick, CalendarCheck, Trophy } from "lucide-react";
import { api } from "@/lib/api";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const dayLabel = (d) => ["S", "M", "T", "W", "T", "F", "S"][new Date(`${d}T12:00:00Z`).getUTCDay()];

export function LinkOpens({ clicks }) {
  const max = Math.max(1, ...clicks.days.map((d) => d.count));
  return (
    <div className="bg-white border border-ink/10 rounded-3xl p-6" data-testid="link-opens">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl font-bold flex items-center gap-2"><MousePointerClick size={18} className="text-terra" /> Link opens</h3>
          <p className="text-xs text-ink/60 mt-1">Unique people who opened your link. Sharing is working when these bars grow.</p>
        </div>
        <div className="text-right shrink-0">
          <p className="font-serif text-3xl font-bold leading-none" data-testid="link-opens-week">{clicks.week}</p>
          <p className="text-[10px] uppercase tracking-wider text-ink/50">last 7 days</p>
        </div>
      </div>
      <div className="mt-5 flex items-end gap-2 h-20" data-testid="link-opens-chart">
        {clicks.days.map((d) => (
          <div key={d.day} className="flex-1 flex flex-col items-center gap-1" title={`${d.day}: ${d.count}`}>
            <span className="text-[10px] text-ink/60 leading-none">{d.count || ""}</span>
            <div className="w-full rounded-t-md bg-terra/80 transition-all" style={{ height: `${Math.max(4, (d.count / max) * 56)}px`, opacity: d.count ? 1 : 0.25 }} data-testid={`link-opens-bar-${d.day}`} />
            <span className="text-[10px] font-mono text-ink/40">{dayLabel(d.day)}</span>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-ink/50"><span className="font-semibold text-ink" data-testid="link-opens-all-time">{clicks.all_time}</span> unique opens all time</p>
    </div>
  );
}

export function LastMonthReport() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/customer/report").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  return (
    <div className="bg-white border border-ink/10 rounded-3xl p-6" data-testid="monthly-report">
      <h3 className="font-serif text-xl font-bold flex items-center gap-2"><CalendarCheck size={18} className="text-gold" /> Your {r.month} report</h3>
      <div className="grid grid-cols-3 gap-3 mt-4">
        <div className="bg-sand rounded-2xl p-3 min-w-0"><p className="font-serif text-2xl font-bold" data-testid="report-bookings">{r.bookings}</p><p className="text-[10px] uppercase tracking-wider text-ink/50">bookings</p></div>
        <div className="bg-sand rounded-2xl p-3 min-w-0"><p className="font-serif text-2xl font-bold truncate" data-testid="report-earned">{inr(r.earned)}</p><p className="text-[10px] uppercase tracking-wider text-ink/50">earned</p></div>
        <div className="bg-sand rounded-2xl p-3 min-w-0"><p className="font-serif text-2xl font-bold flex items-center gap-1" data-testid="report-rank">{r.rank ? <><Trophy size={16} className="text-gold" />#{r.rank}</> : "—"}</p><p className="text-[10px] uppercase tracking-wider text-ink/50">{r.rank ? `of ${r.total_agents}` : "rank"}</p></div>
      </div>
      <p className="mt-3 text-xs text-ink/60" data-testid="report-clicks">{r.clicks} people opened your link in {r.month}.</p>
    </div>
  );
}
